export function restoreSubmittedButton({ button, event, submitted, disabledBeforeSubmit }) {
  if (!event.persisted || !submitted) return false

  button.disabled = disabledBeforeSubmit
  if (disabledBeforeSubmit) {
    button.setAttribute('disabled', '')
  } else {
    button.removeAttribute('disabled')
  }

  button.querySelector('.js-c-form-input-button__loading-state')?.classList.add('tw-hidden')
  return true
}
